/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, FormLabel, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { TimePicker, TimeStepOptions } from "@mui/x-date-pickers";
import React from "react";
import { Control, Controller } from "react-hook-form";

const FormInputContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
`;

const StyledFormLabel = styled(FormLabel)(({ theme }) => ({
  marginBottom: "0.25rem",

  "& .MuiFormLabel-asterisk": {
    color: theme.palette.error.main
  }
}));

export const FormTimePicker = (props: {
  name: string;
  control: Control<any, any>;
  rules: any | undefined;
  label: string;
  required: boolean | undefined;
  onChange?: (event: React.ChangeEvent) => void;
  disabled?: boolean;
  disableFuture?: boolean;
  disablePast?: boolean;
  selectedValue?: any;
  minTime?: Date;
  maxTime?: Date;
  timeSteps?: TimeStepOptions;
}) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={props.rules}
      render={({ fieldState, field }) => (
        <FormInputContainer data-testid={"TIME_PICKER_" + props.name}>
          <StyledFormLabel required={props.required}>
            <Typography display="inline" variant="formLabel">
              {props.label}
            </Typography>
          </StyledFormLabel>
          <TimePicker
            value={props.selectedValue || field.value || undefined}
            disabled={props.disabled}
            disableFuture={props.disableFuture}
            disablePast={props.disablePast}
            minTime={props.minTime}
            maxTime={props.maxTime}
            timeSteps={props.timeSteps}
            onChange={(e: unknown) => {
              const event = e as React.ChangeEvent;
              field.onChange(event);
              props.onChange && props.onChange(event);
            }}
            slotProps={{
              textField: {
                helperText: fieldState.error?.message,
                onBlur: field.onBlur,
                error: !!fieldState.error
              }
            }}
            onClose={field.onBlur}
          />
        </FormInputContainer>
      )}
    />
  );
};

FormTimePicker.defaultProps = {
  rules: undefined,
  required: false,
  disabled: false,
  disableFuture: false
};
